import React, { memo } from 'react';
import { getCreateAccountObject } from '../utils/guidedUtil';
import GlobalModal from '../../global/atoms/globalModal/GlobalModal';
import ErrorIcon from '../../../resources/images/alert-triangle-28.svg';
import './freeEmailModal.scss';
import Button from '../../global/atoms/button';

const FreeEmailModal = props => {
    const { showFreeEmailModal, setShowFreeEmailModal, handleFreeEmailContinue, changeEmailAddress } = props;
    const createAccountScreenConfigs = getCreateAccountObject();
    const {
        verifyEmailTitle = '',
        verifyEmailDescription = '',
        changeEmailButtonLabel = '',
        proceedButtonLabel = ''
    } = createAccountScreenConfigs || {};

    const handleChangeEmail = () => {
        changeEmailAddress();
    };

    const handleContinue = () => {
        handleFreeEmailContinue();
    };

    const getTitle = () => {
        return (
            <>
                <>
                    <ErrorIcon className="freemodal__title-icon" tabIndex={'-1'} aria-hidden={true} />
                    <span className="freemodal__title">{verifyEmailTitle}</span>
                </>
            </>
        );
    };

    const handleModalClose = () => {
        setShowFreeEmailModal(false);
    };

    const getContent = () => {
        return (
            <>
                <div className="freemodal__content" tabIndex={'0'}>
                    <p>{verifyEmailDescription}</p>
                </div>
                <div className="freemodal__actions">
                    <Button
                        tabIndex={0}
                        className={`button button-primary button-block`}
                        buttonAriaLabel={changeEmailButtonLabel}
                        onClick={() => handleChangeEmail()}>
                       {changeEmailButtonLabel}
                    </Button>

                    <Button
                        tabIndex={0}
                        className={'button button-outline-primary button-block'}
                        buttonAriaLabel={proceedButtonLabel}
                        onClick={() => handleContinue(true)}>
                       {proceedButtonLabel}
                    </Button>
                </div>
            </>
        );
    };

    return (
        <GlobalModal
            className={'width-327'}
            isOpen={showFreeEmailModal}
            onRequestClose={handleModalClose}
            title={getTitle()}
            portalClassName={'gr-free-modal'}
            content={getContent()}
            handleClose={handleModalClose}
        />
    );
};

export default memo(FreeEmailModal);
